<template>
  <nav class="tree nav flex-column">
    <a
      class="nav-link"
      href="/">Главная</a>
    <a
      v-for="hook in hooks"
      :key="hook.endpoint"
      :href="`/docs/${hook.endpoint}/`"
      class="nav-link"
    >
      {{ hook.endpoint }}
    </a>
  </nav>
</template>

<script>
export default {
  name: 'Tree',
  props: {
    hooks: { type: Array, required: true },
  },
}
</script>
